module.exports = __webpack_public_path__ + "static/media/ic-no-ecards.d7031a5c.svg";